// context/AppContext.js
import React, { createContext, useReducer } from 'react';
import { dataReducer, initialState} from './reducers/dataReducers';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
    // const initialState = {
    //     product: { products: [] },
    //     // role: { roles: [] },
    //     // permission: { permissions: [] },
    //     // initial states lainnya
    // };

    // const [state, dispatch] = useReducer(rootReducer, initialState);
    const [state, dispatch] = useReducer(dataReducer, initialState);

    return (
        <AppContext.Provider value={{ state, dispatch }}>
            {children}
        </AppContext.Provider>
    );
};
